export const CONSTANTS_LABEL = {
  LABEL_RETIRO_DIRECTO: "Retiro Directo",
  LABEL_TIPO_TRX: "Tipo transaccion",
};
export const CONSTANTS_GRUPO_COMERCIOS = Object.freeze({
  CEAS: "5",
  CRC: "7",
  CDAS: "298",
  CIAS: "133",
});

export const NOMBRE_PLATAFORMA = Object.freeze({
  PDP: "PDP",
  CRD: "Conred",
});
